<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal id="land-modal" size="lg" title="Land Information" hide-footer @hidden="onHidden">
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_type_id">Land type <span class="c-required">*</span></label>
            <select v-model="land.land_type_id"  v-validate="'required'" id="land_type_id" name="land_type_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Land Type</option>
              <option v-for="(land_type, index) in land_types" v-bind:value="land_type.id" :key="index">{{ land_type.id }} : {{ land_type.land_type_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select valid land type
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_ownership_type_id">Land Ownership <span class="c-required">*</span></label>
            <select v-model="land.land_ownership_type_id" v-validate="'required'" id="land_ownership_type_id"
                    name="land_ownership_type_id" class="form-control form-control-sm" @change="cclHide(land.land_ownership_type_id)">
              <option :value="''" selected>Select Land Ownership Type</option>
              <option v-for="(land_ownership_type, index) in land_ownership_types" v-bind:value="land_ownership_type.id" :key="index">{{ land_ownership_type.id }} : {{ land_ownership_type.land_ownership_type_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select valid land ownership type
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="mouza_id">Mouza<span class="c-required">*</span></label>
            <select v-model="land.mouza_id" v-validate="'required'" @change="getPlotSchedule(land.mouza_id);getMoouzaJvcs(land.mouza_id)" id="mouza_id" name="mouza_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Mouza</option>
              <option v-for="(mouza, index) in mouzas" v-bind:value="mouza.id" :key="index">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select valid mouza</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="plot_schedule_id">Plot no.<span class="c-required">*</span></label>
            <select v-model="land.plot_schedule_id" v-validate="'required'"  @change="getKhatianNo(land.plot_schedule_id), cclsLand(land.plot_schedule_id)" id="plot_schedule_id" name="plot_schedule_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Plot No.</option>
              <option v-for="(plot_schedule, index) in data_plot_schedules" v-bind:value="plot_schedule.id" :key="index">{{ plot_schedule.plot_no }}</option>
            </select>
            <div class="invalid-feedback">Please select valid plot no.</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="bs_khatian">khatian No</label>
            <input type="text" disabled v-model="land.bs_khatian"  id="bs_khatian" name="bs_khatian" class="custom-select custom-select-sm"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="self_acc">Under Controlled</label>
            <input type="number" v-model="land.self_acc" v-validate="{ max: 18, regex: /^[0-9]*(?:\.[0-9]{0,8})?$/ }" id="self_acc" name="self_acc" placeholder="In decimal (Only number allowed)" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Please enter under controlled in number format and not greater then 18 digit</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="self_affected">Affected (Available : ** Decimal) <span class="c-required">*</span></label>
            <input type="number" v-if="(land.bs_khatian == 1 && land.land_ownership_type_id == 2) || (land.bs_khatian == 1 && land.land_ownership_type_id == 3)" :disabled="(land.bs_khatian == 1 && land.land_ownership_type_id == 2) || (land.bs_khatian == 1 && land.land_ownership_type_id == 3)" v-model="land.self_affected" value="0.00" id="self_affected" name="self_affected" placeholder="In decimal (Only number allowed)." class="custom-select custom-select-sm"/>
            <input type="number" v-else  v-model="land.self_affected"  v-validate="{ required: true,  max: 18, regex: /^[0-9]*(?:\.[0-9]{0,8})?$/ }" id="self_affected" name="self_affected" placeholder="In decimal (Only number allowed)." class="form-control form-control-sm"/>
            <div class="invalid-feedback">Please enter affected in number format and not greater then 18 digit</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="otherThan_affected">Other than Affected land</label>
            <input type="number"  v-model="land.otherThan_affected"  v-validate="{ max: 18, regex: /^[0-9]*(?:\.[0-9]{0,8})?$/ }"  id="otherThan_affected" name="otherThan_affected" class="form-control form-control-sm" placeholder="In decimal (Only number allowed)"/>
            <div class="invalid-feedback">Please enter other than affected land in number format and not greater then 18 digit</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="remarks">Remarks</label>
            <input v-model="land.remarks" id="remarks" name="remarks" type="text" class="form-control form-control-sm"/>
          </div>

          <!--          <div class="col-md-6 col-sm-6 col-lg-4">-->
          <!--            <label for="is_inc_pay">Is Inc Pay?</label>-->
          <!--            <select v-model="land.is_inc_pay" id="is_inc_pay" name="is_inc_pay" class="form-control form-control-sm">-->
          <!--              <option value="0" selected>No</option>-->
          <!--              <option value="1">Yes</option>-->
          <!--            </select>-->
          <!--          </div>-->
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-4">
            <label for="land_ownership_type_id">JVC <span class="c-required">*</span></label>
            <select v-model="land.jvc_id" id="jvc_id" name="jvc_id" class="form-control form-control-sm" v-validate="'required'">
              <option :value="''" selected>Select JVC</option>
              <option v-for="(jvc, index) in jvcs" v-bind:value="jvc.id" :key="index">JVC No. {{ jvc.jvc_no }}, JVC Date. {{ jvc.jvc_date }} , Number of EP. {{ jvc.number_eps }}</option>
            </select>
            <div class="invalid-feedback">
              Please select valid JVC
            </div>
          </div>
        </div>
        <div v-if="cclShow">
          <h5 class="modal-sub-header">CCL Information</h5>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="ccl_id">CCL<span class="c-required">*</span></label>
              <select v-model="land.ccl_id" v-validate="land.land_ownership_type_id == 1 ? 'required' : '' " @change="getCclInfo(land.ccl_id)"  id="ccl_id" name="ccl_id" class="form-control form-control-sm">
                <option :value="''" selected>Select CCL</option>
                <option v-for="(ccl_land, index) in ccl_lands" v-bind:value="ccl_land.id" :key="index">{{ ccl_land.ccl_no }}</option>
              </select>
              <div class="invalid-feedback">Please select valid CCL</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="ccl_amount" class="col-form-label col-form-label-sm">CCL Amount <span class="c-required">*</span></label>
              <input type="number" :disabled="land.bs_khatian == 1"  v-model="land.ccl_amount" v-validate="land.land_ownership_type_id == 1 ? 'required|decimal' : '' " id="ccl_amount" name="ccl_amount" placeholder="CCL Amount" :class="land.bs_khatian == 1 ? 'custom-select custom-select-sm' : 'form-control form-control-sm'"/>
              <div class="invalid-feedback">Please provide valid CCL Amount</div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="dc_surcharge_id">DC Surcharge<span class="c-required">*</span></label>
              <select v-model="land.dc_surcharge_id" v-validate="land.land_ownership_type_id == 1 ? 'required' : '' " id="dc_surcharge_id" name="dc_surcharge_id" class="form-control form-control-sm">
                <option :value="''" selected>Select DC Surcharge</option>
                <option v-for="(dc_surcharge, index) in dc_surcharges" v-bind:value="dc_surcharge.id" :key="index">{{ dc_surcharge.percentage_surcharge }}</option>
              </select>
              <div class="invalid-feedback">Please select valid DC Rate</div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="cheque_date" class="col-form-label col-form-label-sm">Cheque Date</label>
              <input type="text" disabled v-model="ccl.cheque_date" id="cheque_date" name="cheque_date" class="custom-select custom-select-sm"/>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="book_no" class="col-form-label col-form-label-sm">Book No</label>
              <input type="text" disabled v-model="ccl.book_no" id="book_no" name="book_no" class="custom-select custom-select-sm"/>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-4">
              <label for="book_sub_no" class="col-form-label col-form-label-sm">Sub Book No</label>
              <input type="text" disabled v-model="ccl.book_sub_no" id="book_sub_no" name="book_sub_no" class="custom-select custom-select-sm"/>
            </div>
          </div>
        </div>
        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Land</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Land</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('land-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import updateCclModal from '../data/ccl/modal/updateCclModal'

export default {
  props: ["land", "btn_edit", "cclShow"],

  components: { Datepicker, Multiselect, updateCclModal },
  data() {
    return {
      data_mouzas: [],
      mouzas: [],
      land_types: [],
      land_ownership_types: [],
      la_cases: [],
      lands: [],
      data_ccl_lands: [],
      ccl_lands: [],
      plot_schedules: [],
      data_plot_schedules: [],
      dc_surcharges: [],
      jvcs: [],
      validation_errors: {},
      show: false,
      ccl: {},
      ccl_id: '',
    };
  },
  mounted() {
    this.land.ses_id = this.$route.params.ses_id;
    this.getCodes();
  },
  methods: {
    customFormatter(date) {
      this.land.cheque_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    cclHide(ownershipId) {
      this.$emit("cclShowUpdate", ownershipId == 1 ? true : false);

      var otherThan_affected = document.getElementById("otherThan_affected");
      otherThan_affected.disabled = ownershipId == 3;
      otherThan_affected.class = ownershipId == 3 ? 'custom-select custom-select-sm' : 'form-control form-control-sm';

      var self_affected = document.getElementById("self_affected");
      self_affected.disabled = ownershipId == 3;

      var self_acc = document.getElementById("self_acc");
      self_acc.disabled = ownershipId == 3;
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.land.ses_id = this.$route.params.ses_id;
          http
              .post("api/lands", this.land)
              .then(response => {
                if (!response.data.error) {
                  this.$emit("resetForm");
                  this.$bvModal.hide("land-modal");
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$emit("getPersonLands");
                }
                if (response.data.error == true) {
                  this.$bvToast.toast(response.data.message, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    update() {

      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/lands/" + this.land.land_id, this.land)
              .then(response => {
                if (!response.data.error) {
                  this.$bvModal.hide("land-modal");
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$emit("getPersonLands");
                }
                if (response.data.error == true) {
                  this.$bvToast.toast(response.data.message, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
                this.$bvToast.toast("Update Failed", {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              });
        }
      });
    },
    getCodes() {
      http.get("api/land/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.land_types = data.land_types;
          this.land_ownership_types = data.land_ownership_types;
          this.mouzas = data.mouzas;
          //this.data_plot_schedules = data.plot_schedules;
          this.data_ccl_lands = data.ccl_lands;
          this.dc_surcharges = data.dc_surcharges;
        }
      });
    },
    getMouza(land_type_id, mouza_id){

      if (mouza_id != null) {
        var filteredArray = this.data_ccl_lands.filter(element =>
            element.mouza_id === mouza_id
        )
      }
      this.ccl_lands = filteredArray;

    },


    getPlotSchedule(mouza_id){
      http.get("api/land/codes/PlotSchedule/" + mouza_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.data_plot_schedules = data.plot_schedules;

          //console.log(this.data_plot_schedules)
          //this.data_ccl_lands = data.ccl_lands;
        }
      });

    },

    getMoouzaJvcs(mouza_id){
      http.get("api/land/getJvc/" + mouza_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.jvcs = data.jvcs;

          //console.log(this.jvcs)
          //this.data_ccl_lands = data.ccl_lands;
        }
      });

    },



    cclsLand(plot_schedule_id){
      // let data_land = null;
      // data_land.mouza_id = mouza_id;
      // data_land.land_type_id = land_type_id;
      // data_land.plot_schedule_id = plot_schedule_id;

      http.get("api/land/codes/ccls/land/" + plot_schedule_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.ccl_lands = data.ccl_lands;
          // console.log(plot_schedule_id)

        }
      });
    },

    getCclInfo(ccl_id){
      if(ccl_id){
        let ccl_land = this.ccl_lands.find(v => v.id == ccl_id);
        this.ccl.cheque_date = ccl_land.cheque_date
        this.ccl.book_no = ccl_land.book_no
        this.ccl.book_sub_no = ccl_land.book_sub_no
        this.ccl.amount = ccl_land.amount
        this.ccl.id = ccl_land.id
      }

    },
    getKhatianNo(plot_schedule_id){
      let plotSchedule = this.data_plot_schedules.find(plot_schedule => plot_schedule.id == plot_schedule_id);
      this.land.plot_no = plotSchedule.plot_no;
      this.land.bs_khatian = plotSchedule.bs_khatian;
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
    updateCcl(ccl_id){
      this.ccl_id = ccl_id
      this.$refs.updateCclModal.onUpdate(ccl_id);
      this.$root.$emit("bv::show::modal", "ccl-update-modal");
    },
    onHidden (e) {
      this.$emit("getPersonLands");
    }
  },
};
</script>
<style>
.c-required{
  color: red;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef !important;
  opacity: 1;
}
</style>
